import { createRequiredContext } from '@festina-life/ui/libs'

export type CompareType = 'previous' | 'inherited'
export type CompareFilter =
  | 'documentation'
  | 'variantDocumentation'
  | 'valueConfig'
  | 'required'
  | 'requiredInModelInstance'
  | 'cardinality'
  | 'defaultValue'
  | 'frame'
  | 'variants'
  | 'validations'
  | 'dynamicFunctions'
  | 'parentId'
  | 'defaultSelected'
  | 'selectable'
  | 'replaces'

type CompareContextProps = {
  compareType: CompareType
  shouldCompare: (filter: CompareFilter) => boolean
}

const [useCompareContext, Provider] =
  createRequiredContext<CompareContextProps>('Compare')

export { Provider, useCompareContext }
